import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AccountFacade } from '@edgvr-front/account/data-access';
import { BinaryInstances } from '@edgvr-front/binaries/domain';
import { Env, ENV_TOKEN } from '@edgvr-front/edgvr-front/feature/env';
import { LatestBinariesSelectors } from '@edgvr-front/binaries/data-access';
import { select, Store } from '@ngrx/store';
import { map, Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'edgvr-front-feature-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnDestroy {
  selectedAccount: null | string = null;
  readonly latest$ = this.store.pipe(select(LatestBinariesSelectors.latest));
  readonly installer$ = this.latest$.pipe(
    map((_) => _.find((_) => _.value.instance === BinaryInstances.Installer))
  );
  readonly moduleBuilder$ = this.latest$.pipe(
    map((_) =>
      _.find((_) => _.value.instance === BinaryInstances.ModuleBuilder)
    )
  );

  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(ENV_TOKEN) private readonly env: Env,
    private readonly accountFacade: AccountFacade,
    private readonly store: Store
  ) {}

  get installerFile$() {
    return this.installer$.pipe(map((_) => _?.value.file));
  }

  get moduleBuilderFile$() {
    return this.moduleBuilder$.pipe(map((_) => _?.value.file));
  }

  ngOnInit() {
    this.accountFacade.companies$
      .pipe(
        map((_) => (_ ? Object.keys(_) : [])),
        tap((_) => (this.selectedAccount = _[0] ? _[0] : null)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get contact() {
    return this.env.contact;
  }

  get isLoading$() {
    return this.accountFacade.isLoading$;
  }

  get accounts$() {
    return this.accountFacade.companies$.pipe(
      map((_) => (_ ? Object.keys(_) : null))
    );
  }

  get email$() {
    return this.accountFacade.account$.pipe(map((_) => _?.email || null));
  }

  onReSignIn() {
    this.accountFacade.reSignIn();
  }

  onSignOut() {
    return this.accountFacade.signOut();
  }

  onSelect(e: Event) {
    this.selectedAccount = (e.target as HTMLSelectElement).value;
  }
}
